<section *ngIf="cargo">
  <div class="cargo" [ngStyle]="semaphore"
    *ngIf="cargo && ((typeList === 'loadsInNegotiation' || typeList === 'cargoRequestNegotiation') && isFixedCargo()) || (typeList !== 'loadsInNegotiation' && typeList !== 'cargoRequestNegotiation')"
    [ngClass]="{'item-list-selected': checked, 'border-intermitente-card': hasTransportedValueAlert, 'background-sleep': cargo?.stateTracking === 'Pause' && route?.snapshot?.url[0]?.path === 'loadingRoutes', 'cargo--with-status': isLoadingRoutesTab}">

    <div class="cargo__priority-header">
      <div *ngIf="isLoadingRoutesTab" class="cargo__last-track" [ngStyle]="semaphoreBody">
        <div *ngIf="cargoLastPointLocation.date; else withoutTracking" class="cargo__last-track-section">
          <span class="cargo__last-track-label">Último seguimiento</span>
          <strong class="cargo__last-track-value">
            {{trackingTime[0].toUpperCase() + trackingTime.slice(1)}}
          </strong>
        </div>
        <ng-template #withoutTracking>
          <div class="cargo__last-track-section">
            <strong class="cargo__last-track-value">Sin seguimientos</strong>
          </div>
        </ng-template>
        <div *ngIf="startRouteTime" class="cargo__last-track-section cargo__last-track-section--route-start">
          <span class="cargo__last-track-label">Inicio de ruta</span>
          <strong class="cargo__last-track-value">{{startRouteTime}}</strong>
        </div>
      </div>

      <div class="cargo__transport-company" *ngIf="hasMultipleTransportCompanies && cargo?.transportCompany?.name">
        <div class="cargo__transport-company-icon" aria-hidden="true">
          <i class="fas fa-truck"></i>
        </div>
        <div class="cargo__transport-company-details">
          <span class="cargo__transport-company-label">Empresa de transporte</span>
          <span class="cargo__transport-company-name">{{cargo?.transportCompany?.name}}</span>
        </div>
      </div>

      <!-- Tracking alerts keep their existing interactions and conditions -->
      <div class="cargo__priority-alerts" *ngIf="activeBell || !!badges?.length">
        <app-bell-alert *ngIf="activeBell && isLoadingRoutesTab && showBells" [cargo]="cargo">
        </app-bell-alert>
        <div class="cargo__badges" *ngIf="!!badges?.length">
          <span *ngFor="let alert of badges" class="badge white-space-normal" [ngClass]="alert.style">
            {{ alert.message }}
          </span>
        </div>
      </div>

      <div class="cargo__priority-meta">
        <strong class="cargo__priority-id" title="Consecutivo de servicio Nº {{cargo?.consecutive}}">
          ID {{ (cargo?.consecutive || cargo?.consecutive===0) ? (cargo?.consecutive) : '-' }}
        </strong>
        <div class="cargo__priority-date">
          <span title="Fecha de cargue: {{cargo?.dateLoad | dateFormat:'only-date'}}">
            {{cargo?.dateLoad | dateFormat:'only-date'}}
          </span>
        </div>
      </div>
    </div>

    <div class="cargo__main">
      <!-- Service status and risk profile -->
      <div *ngIf="isLoadingRoutesTab" class="lateral-info cargo__status-rail text-center">
        <div class="semaphore-states">
          <div class="cargo__status-item">
            <span>Estado del servicio</span>
            <i *ngIf="isSatelliteLockService" class="fas fa-unlock-alt fa-lg cargo-lock-icon"></i>
            <img *ngIf="!isSatelliteLockService" [src]="'../../../../assets/svg/icons/'+incident.asset" width="32"
              alt="">
            <b>{{incident.name}}</b>
          </div>
          <div class="cargo__status-item cargo__status-item--risk">
            <span>Perfil de riesgo</span>
            <i class="circle" [ngStyle]="trackingRiskProfileBg">&nbsp;</i>
            <b>{{trackingRiskProfile}}</b>
          </div>
        </div>
      </div>

      <!-- General Data -->
      <div class="cargo__content">
        <!-- State of approval -->
        <div class="cargo__alert" *ngIf="showInfoAlertsCargo">
          <div class="col-lg-12 alert alert-info" *ngIf="infoAlertsCargo.stateApproval" permission-display
            [module]="permission.cargo.module" [functionality]="permission.cargo.viewApproveInfo">
            Estado de la aprobación:
            <span class="text-bold">
              {{cargo?.approval === 'Approved' ? 'Aprobado'
              : cargo?.approval === 'Rejected' ? 'Rechazado'
              : 'Pendiente de aprobación'}}
            </span>
          </div>
          <div class="col-lg-12 alert alert-info" *ngIf="infoAlertsCargo.stateRndcFulfillment" permission-display
            [module]="permission.cargo.module" [functionality]="permission.cargo.viewApproveInfo">
            Estado del servicio:
            <span class="text-bold">
              {{utils.isDefined(cargo?.ministryFulfillment) && cargo?.ministryFulfillment === true ? 'Cumplido' :
              !this.utils.isDefined(cargo?.ministryFulfillment) && cargo.approval === 'Approved' ? 'Cumplido' :
              'Pendiente de cumplir'}}
            </span>
          </div>
          <div class="col-lg-12 alert alert-info text-bold text-center underline cursor-pointer"
            *ngIf="infoAlertsCargo.showAdvanceAccount && (isTransportService || isEscortedService)"
            (click)="showBankAccountHolder('advance')">
            <i class="fa fa-user mr-2"></i>
            Ver titular de la cuenta de anticipos
          </div>
          <div class="col-lg-12 alert alert-info text-bold text-center underline cursor-pointer"
            *ngIf="infoAlertsCargo.showBalanceAccount && (isTransportService || isEscortedService)"
            (click)="showBankAccountHolder('balance')">
            <i class="fa fa-user mr-2"></i>
            Ver titular de la cuenta de saldos
          </div>
        </div>
        <div class="w-100 alert alert-info d-flex align-items-center justify-content-center mb-2 px-2 py-1 text-bold"
          role="alert" *ngIf="loadingCargo">
          <i class="fas fa-spinner fa-spin mr-2"></i>
          <span>Recargando datos...</span>
        </div>

        <div class="row cargo__header" *ngIf="cargo?.state === cargoStateEnum.CREATED && showTurnVehicles">
          <div class="col-sm-12">
            <!-- Turn Vehicles -->
            <div class="text-turn d-none d-md-block" [ngClass]="{
              'color-primary': filteredCargosTurns && filteredCargosTurns?.matches && filteredCargosTurns?.matches?.length,
              'color-primary-dark': !filteredCargosTurns || (filteredCargosTurns && filteredCargosTurns?.matches?.length === 0),
              'cursor-pointer': filteredCargosTurns && filteredCargosTurns?.matches && filteredCargosTurns?.matches?.length
            }"
              [title]="filteredCargosTurns && filteredCargosTurns.matches && filteredCargosTurns.matches.length ? 'Ver lista de vehiculos enturnados' : ''"
              (click)="AvaliableTurnList()">
              <u>
                {{ filteredCargosTurns?.matches?.length ?
                ('(' + filteredCargosTurns?.matches?.length + ')' + ' Vehículo' +
                (filteredCargosTurns?.matches?.length > 1 ? 's' : '') +
                ' enturnado' +
                (filteredCargosTurns?.matches?.length > 1 ? 's' : '') +
                ' disponible' +
                (filteredCargosTurns?.matches?.length > 1 ? 's' : ''))
                : '(0) Vehículos enturnados disponibles'}}
              </u>
            </div>
          </div>
        </div>
        <div class="cargo__header-actions" *ngIf="showItemOptions">
          <button mat-raised-button class="primary-secondary button-width-auto" type="button" color="primary"
            (click)="openDetail(cargo)" *ngIf="canEditCargo">
            <span>Seguir diligenciando</span>
          </button>
          <button mat-raised-button class="primary" color="primary" (click)="selectDriver(cargo)"
            *ngIf="!cargo.assignedDriver && !cargo.licensePlate && showAssignVehicleBtn && cargo.zone !== 'reserved'">
            <div class="container-number" *ngIf="visualNumberOfOffers">
              {{visualNumberOfOffers}}
            </div>
            <span>Postulaciones</span>
          </button>
        </div>

        <div class="cargo__details-row cargo__details-row--identity">
          <div class="cargo__field cargo__field--client">
            <div class="label">Código del cliente</div>
            <div class="label-field">
              {{cargo?.numberDocumentSender ? cargo?.numberDocumentSender : '-'}}
            </div>
          </div>
          <div class="cargo__field cargo__field--contractor">
            <div class="label">Contratante</div>
            <div class="label-field">
              {{cargo?.cargoOwner?.documentNumber === cargo?.idCompany?
              cargo?.cargoOwner?.name :
              cargo?.idCompany ? (cargo?.idCompany | companyName):''}}
            </div>
          </div>
          <div class="cargo__field cargo__field--owner">
            <div class="label">Propietario {{cargo?.ministry ? 'de las remesas' : 'del servicio'}}</div>
            <div class="label-field">
              {{cargo?.cargoOwner?.name ? cargo?.cargoOwner?.name : cargo?.idCompany | companyName}}
            </div>
          </div>
          <div class="cargo__field cargo__field--origin">
            <div class="label">
              Origen
            </div>
            <div class="text-bold label-field">
              <span>
                {{cargo?.cargoFeature?.uploadDownload?.origin?.name}}
                {{cargo?.cargoFeature?.uploadDownload?.origin?.country?
                '('+cargo?.cargoFeature?.uploadDownload?.origin?.country?.name+')':''}}
              </span>
            </div>
          </div>
          <div class="cargo__field cargo__field--destination">
            <div class="label">
              Destino
            </div>
            <div class="text-bold label-field">
              <span>
                {{
                cargo?.cargoFeature?.uploadDownload?.destination?.length
                ? cargo.cargoFeature.uploadDownload.destination[
                cargo.cargoFeature.uploadDownload.destination.length - 1
                ]?.name
                : ''
                }}
                {{
                cargo?.cargoFeature?.uploadDownload?.destination?.length &&
                cargo.cargoFeature.uploadDownload.destination[
                cargo.cargoFeature.uploadDownload.destination.length - 1
                ]?.country
                ? '(' +
                cargo.cargoFeature.uploadDownload.destination[
                cargo.cargoFeature.uploadDownload.destination.length - 1
                ].country?.name +
                ')'
                : ''
                }}
              </span>
            </div>
          </div>
        </div>

        <div class="cargo__details-row cargo__details-row--operation">
          <div class="cargo__field" *ngIf="isEscortedService||isTransportService">
            <div class="label">
              {{isEscortedService? 'Vehículo escolta' : 'Placa'}}
            </div>
            <div class="text-bold label-field" [ngClass]="{'underline': showVehicleDetail && cargo?.licensePlate}">
              <span (click)="cargo?.licensePlate && showVehicleDetail? getDetailVehicle(true) : null">
                {{ cargo?.licensePlate || '-' }}
              </span>
            </div>
          </div>
          <div class="cargo__field"
            *ngIf="[cargoStateEnum.END_SERVICE, cargoStateEnum.START_SERVICE].includes(cargo?.state) && cargo?.driver">
            <div class="label">
              Conductor
            </div>
            <div class="text-bold label-field" [ngClass]="{'underline': showDriverDetail}">
              <span (click)="getDetailUserByDocument()">
                {{cargo?.driver}}
              </span>
            </div>
          </div>
          <div class="cargo__field" *ngIf="cargo?.escortedVehicle?.licensePlate">
            <div class="label">
              Vehículo {{isEscortedService ? 'escoltado' : 'a seguir'}}
            </div>
            <div class="text-bold label-field cursor-pointer">
              <u [matTooltip]="escortedVehicleTooltip" matTooltipPosition="above" matTooltipClass="extended-tooltip">
                {{cargo?.escortedVehicle?.licensePlate}}
              </u>
            </div>
          </div>
          <div class="cargo__field" *ngIf="cargo?.lock?.imei">
            <div class="label">
              Candado satelital
            </div>
            <div class="text-bold label-field">
              {{cargo?.lock?.type?.name}} - {{cargo?.lock?.id}} (IMEI: {{cargo?.lock?.imei}})
            </div>
          </div>
          <div class="cargo__field cargo__field--address"
            *ngIf="cargo?.state === cargoStateEnum.START_SERVICE  && cargoLastPointLocation?.address && cargoLastPointLocation?.address !== '-'">
            <div class="label">Dirección</div>
            <div class="text-bold label-field">{{cargoLastPointLocation?.address}}</div>
          </div>
          <div class="cargo__field"
            *ngIf="cargo?.state === cargoStateEnum.START_SERVICE && cargoLastPointLocation?.city && cargoLastPointLocation?.city !== '-'">
            <div class="label">Ciudad</div>
            <div class="text-bold label-field">{{cargoLastPointLocation?.city}}</div>
          </div>
          <div class="cargo__field" *ngIf="cargo?.observation">
            <div class="label">Observaciones</div>
            <div class="text-bold label-field cursor-pointer">
              <span *ngIf="cargo?.observation"><u matTooltip="{{cargo?.observation}}" matTooltipPosition="above"
                  matTooltipClass="extended-tooltip">Servicio</u></span>
              <span *ngIf="cargo?.observationDriver"> - <u matTooltip="{{cargo?.observationDriver}}"
                  matTooltipPosition="above" matTooltipClass="extended-tooltip">Conductor</u></span>
            </div>
          </div>
          <figure class="icon-arrow-container" (click)="openDetail(cargo)" *ngIf="!hideOptionsLoad">
            <img src="/assets/svg/icons/icon-arrow-right-short.png" alt="">
          </figure>
        </div>

        <div class="cargo__details-row cargo__details-row--amounts">
          <div class="cargo__field" *ngIf="isTransportService">
            <div class="label">
              Valor Transportado
            </div>
            <div class="text-bold label-field">
              <span>
                {{utils.isDefined(cargo?.cargoFeature?.cargoMeasure?.amount) ?
                (cargo?.cargoFeature?.cargoMeasure?.amount
                |
                currency:'COP':'code'):'-'}}
              </span>
            </div>
          </div>
          <!-- Rate -->
          <div class="cargo__field" *ngIf="hasPermissionFinancier && hasPermissionShowRateCargo">
            <div class="label">
              Tarifa
            </div>
            <div class="text-bold label-field">
              <span>
                {{
                cargo?.shippingCost?.rate !== null && cargo?.shippingCost?.rate !== undefined
                ? (cargo.shippingCost.rate | currency: 'COP':'code')
                : '-'
                }}
              </span>

            </div>
          </div>
          <div class="cargo__field" *ngIf="hasPermissionFinancier">
            <div class="label">
              Total de la tarifa
            </div>
            <div class="text-bold label-field">
              <span title="{{cargo?.shippingCost?.rate}}">
                {{
                (cargo?.shippingCost?.totalCost !== null && cargo?.shippingCost?.totalCost !== undefined) &&
                (cargo?.shippingCost?.rate !== null && cargo?.shippingCost?.rate !== undefined)
                ? (cargo.shippingCost.rate + cargoItemService.getTotalAdditionalRateDriver(cargo) |
                currency:'COP':'code')
                : '-'
                }}
              </span>

            </div>
          </div>
          <!-- Total Cost -->
          <div class="cargo__field" *ngIf="hasPermissionFinancier && (isTransportService || isEscortedService)">
            <div class="label">
              Flete
            </div>
            <div class="text-bold label-field">
              {{
              cargo?.shippingCost?.totalCost !== null && cargo?.shippingCost?.totalCost !== undefined
              ? (cargo?.shippingCost?.totalCost | currency: 'COP':'code')
              : '-'
              }}
            </div>
            <div class="text-bold label-field" *ngIf="cargoPaymentsService.getTotalBonuses(cargo)">
              <span class="title-4 text__color color--success"
                title="Bonificaciones: + {{cargoPaymentsService.getTotalBonuses(cargo)}}">
                <span class="text__color color--success">(+)</span>
                <a class="text__color color--success text-underlined" role="button"
                  (click)="openShippingCostDetails(0)">{{cargoPaymentsService.getTotalBonuses(cargo) |
                  currency:'COP':'code'}}</a>
              </span>
            </div>
            <div class="text-bold label-field" *ngIf="cargoPaymentsService.getTotalDiscounts(cargo)">
              <span class="title-4 text__color color--error"
                title="Descuentos: + {{cargoPaymentsService.getTotalDiscounts(cargo)}}">
                <span class="text__color color--error">(-)</span>
                <a class="text__color color--error text-underlined" role="button"
                  (click)="openShippingCostDetails(1)">{{cargoPaymentsService.getTotalDiscounts(cargo) |
                  currency:'COP':'code'}}</a>
              </span>
            </div>
          </div>
          <div class="cargo__field" permission-display [module]="permission.cargo.module"
            *ngIf="isTransportService || isEscortedService" [functionality]="permission.cargo.showTotalCostCargo">
            <div class="label">
              Total del flete
            </div>
            <div class="text-bold label-field" *ngIf="cargo?.shippingCost?.paid">
              <span class="text__color color--success">
                Pagada
              </span>
            </div>
            <div class="text-bold label-field" *ngIf="!cargo?.shippingCost?.paid">
              <span *ngIf="(cargo?.shippingCost?.totalCost + cargoItemService.getTotalAdditionalCostsDriver(cargo))
            ||(cargo?.shippingCost?.totalCost + cargoItemService.getTotalAdditionalCostsDriver(cargo)===0)">
                {{cargo?.shippingCost?.totalCost + cargoItemService.getTotalAdditionalCostsDriver(cargo) |
                currency:'COP':'code'}}
              </span>
            </div>
            <div class="text-bold label-field" *ngIf="cargo?.shippingCost?.paid">
              <span>
                {{cargo?.shippingCost?.totalPaid | currency:'COP':'code'}}
              </span>
            </div>
          </div>
          <div class="cargo__field" *ngIf="cargo?.state != cargoStateEnum.START_SERVICE && isTransportService">
            <div class="label">
              Peso del servicio
            </div>
            <div class="text-bold label-field">
              <span>
                {{cargo?.cargoFeature?.cargoMeasure?.totalWeigth ? cargo?.cargoFeature?.cargoMeasure?.totalWeigth :
                '0'}}
              </span>
            </div>
          </div>
          <div class="cargo__field" *ngIf="cargo?.additionalCosts?.length && isTransportService">
            <div class="label">
              Servicios adicionales
            </div>
            <div class="text-bold label-field underline">
              <span (click)="showAdditionalServiceCargo()">
                Ver servicios adicionales
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="cargo__footer">

      <!-- Body Financier-->
      <div class="row cargo__body cargo__body--financier" *ngIf="hasPermissionFinancier"
        [class.cargo__body--negative-balance]="balance < 0">
        <!-- Rate -->
        <div class="col-lg-2 col-sm-4" *ngIf="isTransportService || isEscortedService">
          <span class="title-purple label">
            Anticipo:
          </span>
          <span class="text-bold label text__color color--success" *ngIf="cargo?.shippingCost?.advanceState">
            {{cargoItemService.getPayableAdvance(cargo, balance)
            ? 'Pagado ('+ (cargoItemService.getPayableAdvance(cargo, balance) | currency:'COP':'code':'0.2') + ')'
            : cargoItemService.getPayableAdvance(cargo, balance) | currency:'COP':'code':'0.2'
            }}
          </span>

          <span class="text-bold label-field"
            *ngIf="(cargo?.shippingCost?.valueAdvance || cargo?.shippingCost?.valueAdvance===0) && !cargo?.shippingCost?.advanceState">
            {{cargoItemService.getPayableAdvance(cargo, balance) | currency:'COP':'code':'0.2'}}
          </span>
        </div>
        <div class="col-lg-2 col-sm-4 d-flex flex-column" *ngIf="isEscortedService || isTransportService">
          <div>
            <span class="title-purple label">
              Saldo:
            </span>
            <span class="text-bold label text__color color--success" *ngIf="cargo?.shippingCost?.balanceState">
              Pagado ({{cargoItemService.getCargoBalancePaid(mergedCargo) | currency:'COP':'code':'0.2'}})
            </span>
            <span class="text-bold label-field" *ngIf="!cargo?.shippingCost?.balanceState"
              [class.cargo__negative-balance-value]="balance < 0">
              {{cargo?.shippingCost ?
              (balance |
              currency:'COP':'code':'0.2')
              : '-'}}
            </span>
          </div>
          <div *ngIf="balance > 0">
            <span class="title-purple label cursor-pointer" (click)="summaryBalance(cargo)">
              <u>Ver detalle saldo</u>
            </span>
          </div>
        </div>
        <div class="col-lg-2 col-sm-4" *ngIf="isTransportService">
          <span class="title-purple label">
            Reteica:
          </span>
          <span class="text-bold label-field">
            {{
            cargo?.shippingCost?.reteicaValue !== null && cargo?.shippingCost?.reteicaValue !== undefined
            ? (cargo?.shippingCost?.reteicaValue | cargoTaxes:isChargeTaxes | currency:'COP':'code':'0.2')
            : '-'
            }}
          </span>
        </div>
        <div class="col-lg-2 col-sm-4" *ngIf="isTransportService">
          <span class="title-purple label">
            Retefte:
          </span>
          <span class="text-bold label-field">
            {{
            cargo?.shippingCost?.retefteValue !== null && cargo?.shippingCost?.retefteValue !== undefined
            ? (cargo?.shippingCost?.retefteValue | cargoTaxes:isChargeTaxes | currency:'COP':'code':'0.2')
            : '-'
            }}
          </span>
        </div>
        <div class="col-lg-2 col-sm-4" *ngIf="isTransportService && cargo?.shippingCost?.fopatValue">
          <span class="title-purple label">
            FOPAT:
          </span>
          <span class="text-bold label-field">
            {{
            cargo?.shippingCost?.fopatValue? (cargo?.shippingCost?.fopatValue | cargoTaxes:isChargeFopat |
            currency:'COP':'code':'0.2')
            : '-'
            }}
          </span>
        </div>
        <div class="col-lg-2 col-sm-4"
          *ngIf="cargo?.state === cargoStateEnum.END_SERVICE && hasFastPaymentEnabled && isTransportService">
          <span class="title-purple label">
            Pronto pago solicitado:
          </span>
          <span class="text-bold label-field">
            {{ cargo?.fastPayment ? 'Sí' : 'No' }}
          </span>
        </div>
        <div class="col-lg-6 cargo__financial-service-usage" *ngIf="showAppUsageDiscount && isTransportService">
          <span class="title-purple label">
            Servicios Tecnológicos en Nube - Plataforma Digital de Transporte / Servicios adicionales:
          </span>
          <span class="text-bold label-field">
            {{
            cargo?.shippingCost && utils.isDefined(cargo?.shippingCost?.totalCost)
            ? (cargo?.shippingCost?.integralValue | currency:'COP':'code':'0.2')
            : '-'
            }}
          </span>
        </div>
        <div *ngIf="[cargoStateEnum.END_SERVICE].includes(cargo?.state) && typeList !== 'approvePayments'"
          permission-display class="col-lg-6" [module]="permission.cargo.module"
          [functionality]="permission.cargo.viewApproveInfo">
          <span class="title-purple label">
            Estado de la aprobación:
          </span>
          <span class="text-bold label-field">
            {{cargo?.approval === 'Approved' ?
            utils.isDefined(cargo?.ministryFulfillment) && !cargo?.ministryFulfillment ? 'Aprobado sin cumplir' :
            'Aprobado'
            : cargo?.approval === 'Rejected' ? 'Rechazado'
            : 'Pendiente de aprobación'}}
          </span>
        </div>
      </div>
      <div class="row cargo__body cargo__body--financier relative" *ngIf="getShowAdditionalService() && hasPermissionFinancier &&
          (getValueAdditionalCost('Servicio cargue') ||
          getValueAdditionalCost('Servicio descargue') ||
          getValueAdditionalCost('Stand by'))">
        <div class="col-lg-4" *ngIf="getValueAdditionalCost('Servicio cargue')">
          <span class="title-purple label">
            Serv. Cargue
          </span>
          <span class="text-bold label-field">
            {{getValueAdditionalCost('Servicio cargue') | currency:'COP':'code':'0.2'}}
          </span>
        </div>
        <div class="col-lg-4" *ngIf="getValueAdditionalCost('Servicio descargue')">
          <span class="title-purple label">
            Serv. Descargue
          </span>
          <span class="text-bold label-field">
            {{getValueAdditionalCost('Servicio descargue') | currency:'COP':'code':'0.2'}}
          </span>
        </div>
        <div class="col-lg-4" *ngIf="getValueAdditionalCost('Stand by')">
          <span class="title-purple label">
            Serv. Stand by
          </span>
          <span class="text-bold label-field">
            {{getValueAdditionalCost('Stand by') | currency:'COP':'code':'0.2'}}
          </span>
        </div>
      </div>

      <div class="row cargo__body cargo__body--financier relative"
        *ngIf="hasPermissionFinancier && typeList == 'paymentTravelExpenses' && !!travelExpense">
        <div class="col-md-4">
          <span class="title-purple label">
            {{travelExpense?.travelExpensesType?.name}}
          </span>
          <span class="text-bold label-field" *ngIf="!travelExpense?.paid">
            {{travelExpense?.totalPaid | currency:'COP':'code':'0.2'}}
          </span>
          <span class="text-bold label text__color color--success" *ngIf="travelExpense?.paid">
            Pagado ({{travelExpense?.totalPaid | currency:'COP':'code':'0.2'}})
          </span>
        </div>
      </div>

      <!-- Message validated documents vehicle -->
      <div class="cargo__alert" *ngIf="showWarningAlertsCargo">
        <div class="col-lg-12 alert alert-warning">
          <div *ngIf="warningAlertsCargo.isPendingApproveBankAccount">
            <i class="fas fa-exclamation-triangle"></i>
            {{'Los documentos para pago del vehículo '}}
            <span class="font-weight-bold">{{cargo?.licensePlate}}</span>
            {{' no están validados.'}}
            <small *ngIf="showVehicleDetail">
              <span class="font-wight-bold underline text-uppercase" (click)="getDetailVehicle(true)">
                Ir a Validar
              </span>
            </small>
          </div>
          <div *ngIf="warningAlertsCargo.isPendingConfirmLicensePlate">
            <i class="fas fa-exclamation-triangle"></i>
            {{isEscortedService?'El vehículo escolta ': isSatelliteLockService?'El candado satelital ': 'La placa '}}
            <span class="font-weight-bold">{{cargo?.licensePlate}}</span>
            {{'aún no se ha confirmado para iniciar este servicio.'}}
            <small><span class="font-wight-bold underline text-uppercase"
                (click)=" confirmDriverValidations()">Confirmar {{isEscortedService? 'escolta' : isSatelliteLockService?
                'candado satelital' : 'placa'}}</span></small>
          </div>
          <div *ngIf="warningAlertsCargo.isPendingApproveBalance">
            <i class="fas fa-exclamation-triangle"></i>
            No se ha aprobado el pago del saldo, se debe confirmar desde la aplicación móvil o los
            encargados.
            <small>
              <span class="font-wight-bold underline text-uppercase" (click)="validateApproveBalance()">
                ¿Quién puede Aprobar?
              </span>
            </small>
          </div>
          <div *ngIf="warningAlertsCargo.isPendingApprove">
            <i class="fas fa-exclamation-triangle"></i>
            No se ha aprobado el servicio
          </div>
          <div *ngIf="warningAlertsCargo.isPendingApproveTravelExpense">
            <i class="fas fa-exclamation-triangle"></i>
            Hay viáticos pendientes de legalización. <span class="underline"
              (click)="showLegalizeTravelExpensesDialog()">Ir a legalizar</span>
          </div>
        </div>
      </div>
    </div>

    <div class="cargo__actions">
      <app-cargo-options class="cargo-options" type="ellipsis" [cargo]="mergedCargo || cargo" [typeList]="typeList"
        [isNegotiation]="isNegotiation" (refreshListCargo)="applyFilter.emit()">
      </app-cargo-options>
    </div>
  </div>
</section>

<!-- Menu optionsCargo -->
<mat-menu #optionsCargo="matMenu">
  <button mat-menu-item>
    <mat-icon><i class="fas fa-check-square"></i></mat-icon>
    <span>completada</span>
  </button>
</mat-menu>